"use client"

import { INITIAL_LOCALES } from "@/libs/constants"
import { handleHrefChangeLocale } from "@/libs/functions"
import clsx from "clsx"
import Link from "next/link"
import { usePathname } from "next/navigation"
import React from "react"
interface LocaleLinkProps {
    locale: string
    className?: string
    item: string
    referrer?: string
}

const LinkedLocale: React.FC<LocaleLinkProps> = ({ item, className, locale, referrer }) => {
    const pathname = usePathname()
    return (
        <Link href={handleHrefChangeLocale(locale, item, pathname, referrer) as any} // handleHrefChangeLocale(locale, item, pathname, referrer)
            passHref
            className={clsx(className,
                "text-decoration-none",
                item === locale ? "disabled" : "cursor-pointer"
            )}>
            {item}
        </Link>
    )
}

interface LocaleProps {
    locale: string,
    referrer?: string
}
const Locale: React.FC<LocaleProps> = ({ locale = 'vi-VN', referrer }) => {

    const [show, setShow] = React.useState(false)
    const handleCloseDropdown = () => setShow(false)
    return (
        <div className="menu-dropdown my-auto"
            onMouseDown={() => setShow(true)}
            onMouseOver={() => setShow(true)}
            onMouseEnter={() => setShow(true)}
            onMouseLeave={handleCloseDropdown}
        >
            <div className="my-auto d-flex locales bg-lavender">
                <span className="my-auto ms-2 mt-1 text-uppercase cursor-pointer">
                    {locale.split("-")[0] || "en"}
                </span>
            </div>
            <div className={clsx("menu-linked bg-white rounded-bottom p-3", show ? "menu-toggle-on" : "")}
                onMouseLeave={handleCloseDropdown}>
                {INITIAL_LOCALES.map((item: string, index: number) => {
                    return <LinkedLocale
                        locale={locale}
                        referrer={referrer}
                        item={item}
                        className={index !== 0 ? "mt-1" : ""}
                        key={index} />
                })}
            </div>
        </div >
    )
}
export default Locale